(() => {
  const initialized = new WeakSet();
  const initialize = scope => {
    scope.querySelectorAll('.feestxl-product-section').forEach(section => {
      if (initialized.has(section)) return;
      initialized.add(section);
      const quantity = section.querySelector('[data-feestxl-qty]');
      if (quantity) {
        const updateQuantity = () => { quantity.form.dataset.fxlQuantity = quantity.value; };
        updateQuantity();
        quantity.addEventListener('input', updateQuantity);
        quantity.addEventListener('change', updateQuantity);
      }
      const slides = [...section.querySelectorAll('.feestxl-gallery__slide')];
      const thumbs = [...section.querySelectorAll('.feestxl-gallery__thumb')];
      let active = Math.max(0, slides.findIndex(slide => slide.classList.contains('is-active')));
      const show = (index, scrollThumbnail = true) => {
        if (!slides.length) return;
        active = (index + slides.length) % slides.length;
        slides.forEach((slide, i) => {
          slide.classList.toggle('is-active', i === active);
          slide.setAttribute('aria-hidden', String(i !== active));
          slide.querySelectorAll('video').forEach(video => {
            if (i !== active) {
              video.pause();
              return;
            }
            video.muted = true;
            video.playsInline = true;
            video.play()?.catch(() => {});
          });
          const external = slide.querySelector('[data-gallery-external-video]');
          if (external) {
            if (i === active && !slide.querySelector('iframe')) {
              slide.append(external.content.cloneNode(true));
            } else if (i !== active) {
              slide.querySelectorAll('iframe').forEach(frame => frame.remove());
            }
          }
        });
        thumbs.forEach((thumb, i) => { thumb.classList.toggle('is-active', i === active); thumb.setAttribute('aria-current', String(i === active)); });
        if (scrollThumbnail) thumbs[active]?.scrollIntoView({ block: 'nearest', inline: 'nearest' });
      };
      show(active, false);
      section.addEventListener('change', event => {
        if (event.target.matches('[data-feestxl-variant-select]')) {
          const url = new URL(location.href); url.searchParams.set('variant', event.target.value); location.assign(url);
        }
      });
      section.addEventListener('click', async event => {
        const thumb = event.target.closest('[data-target-media]');
        if (thumb) show(thumbs.indexOf(thumb));
        if (event.target.closest('[data-gallery-prev]')) show(active - 1);
        if (event.target.closest('[data-gallery-next]')) show(active + 1);
        const amountButton = event.target.closest('[data-qty-minus],[data-qty-plus]');
        if (amountButton) {
          const input = section.querySelector('[data-feestxl-qty]');
          const change = amountButton.hasAttribute('data-qty-plus') ? 1 : -1;
          const min = Number(input.min) || 1;
          const step = Number(input.step) || 1;
          const max = input.max ? min + Math.floor((Number(input.max) - min) / step) * step : Infinity;
          const current = Number(input.value) || min;
          const position = (current - min) / step;
          const next = min + (change > 0 ? Math.floor(position) + 1 : Math.ceil(position) - 1) * step;
          input.value = String(Math.max(min, Math.min(max, next)));
          input.form.dataset.fxlQuantity = input.value;
          input.dispatchEvent(new Event('change', { bubbles: true }));
        }
        const relatedAmount = event.target.closest('[data-related-minus],[data-related-plus]');
        if (relatedAmount) {
          const id = relatedAmount.dataset.relatedMinus || relatedAmount.dataset.relatedPlus;
          const input = section.querySelector(`[data-related-qty="${id}"]`);
          if (input) input.value = String(Math.max(1, Number(input.value) + (relatedAmount.hasAttribute('data-related-plus') ? 1 : -1)));
        }
        const scroll = event.target.closest('[data-related-prev],[data-related-next]');
        if (scroll) {
          const track = section.querySelector('.feestxl-related__track');
          const width = track?.querySelector('.fxl-product-card, .feestxl-related-card')?.offsetWidth || 220;
          track?.scrollBy({ left: (scroll.hasAttribute('data-related-next') ? 1 : -1) * (width + 12), behavior: 'smooth' });
        }
        const add = event.target.closest('[data-related-add]');
        if (!add || add.disabled) return;
        const input = section.querySelector(`[data-related-qty="${add.dataset.relatedAdd}"]`);
        add.disabled = true;
        try {
          const response = await window.FXLStock.request(`${window.Shopify?.routes?.root || '/'}cart/add.js`, { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ id: Number(add.dataset.relatedAdd), quantity: Math.max(1, Number(input?.value) || 1) }) });
          const result = await response.json();
          if (!response.ok) throw new Error(result.description || section.dataset.addError);
          document.dispatchEvent(new CustomEvent('cart:updated'));
          if (window.fxlRefreshCartPopup) await window.fxlRefreshCartPopup({ title: result.product_title || result.title });
          else location.assign(`${window.Shopify?.routes?.root || '/'}cart`);
        } catch (error) {
          let message = section.querySelector('[data-fxl-product-error]');
          if (!message) { message = document.createElement('p'); message.className = 'fxl-form-error'; message.dataset.fxlProductError = ''; message.setAttribute('role', 'alert'); add.closest('.feestxl-related-card').append(message); }
          message.textContent = error.message;
        } finally { add.disabled = false; }
      });

    });
  };
  initialize(document);
  document.addEventListener('shopify:section:load', () => initialize(document));
})();


